import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useGetCertOrdersQuery, useGetOrdersQuery } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";
import { OrdersList } from "./OrdersList";

export const Orders = () => {

    const navigate = useNavigate();
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const { isLoading, data: orders, refetch, error, isFetching } = useGetOrdersQuery({ pageIndex, pageSize, stringFilter });

    return (
        <Container>
            <h3>Заказы</h3>
            {error ?
                <div>
                    {error && <div>
                        <h1>Error code: {error.status}</h1>
                        <p>{error.data}</p>
                    </div>
                    }
                </div> :
                <div>
                    <div className="d-flex">
                        <input type={`text`} id="stringFilter" onChange={
                            (e) => setTimeout(() => { setStringFilter(e.target.value) }, 2000)}
                            placeholder="Поиск.." name="stringFilter" className="form-control" />
                    </div>
                    <div>
                        {isLoading ?
                            <LoadScreen></LoadScreen> :
                            <OrdersList pageIndex={pageIndex} setPageIndex={setPageIndex} navigate={navigate} orders={orders.getOrder} totalPages={orders.totalPages} />
                        }
                    </div>
                </div>
            }
        </Container>
    )
}